export * from './deleteWorkspaceQuizzes';
export * from './createWorkspaceQuiz';
export * from './getWorkspaceQuizzes';
export * from './importWorkspaceQuizBySoc';
